var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$routerHistory.hasPrevious())?_c('router-link',{staticClass:"m-r-10 btn-nav btn-back apretable",attrs:{"to":{ path: _vm.$routerHistory.previous().path }}},[_c('i',{staticClass:"bi bi-arrow-left"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }